import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'
const baseURL = process.env.NODE_ENV === 'production' ? '/app' : '/api'


const statusMessage = {
  400: '请求错误',
  401: '未授权的访问，请登录',
  403: '被拒绝的请求',
  404: '请求的资源不存在',
  405: '请求方法错误',
  406: '请求格式错误',
  408: '请求超时',
  410: '请求的资源已被永久删除',
  413: '请求数据过大',
  414: '请求链接过长',
  500: '服务器错误',
}

const SUCCESS_STATUS = 200

class HttpRequest {

  constructor() {
    this.service = axios.create({
      baseURL: baseURL,
      timeout: 60000,
    })


    this.service.defaults.headers.post['Content-Type'] = 'application/json'

    this.requestInterceptor = this.service.interceptors.request.use(config => {
      const token = sessionStorage.getItem("gl_token") || "";

      if (token) config.headers['Access-Token'] = token
      return config
    }, error => {

      return Promise.reject(error)
    })

    this.responseInterceptor = this.service.interceptors.response.use(response => {
      const { config, data } = response
      console.log(`【${config.method.toUpperCase()} ${config.url.replace(config.baseURL, '')}】请求成功，响应数据：%o`, data)
      if (data.code !== SUCCESS_STATUS) {
        const { code, message } = data
        if (code === 501) {
          console.log(code)
          sessionStorage.setItem("gl_token", '');
          sessionStorage.setItem("user_info", '');
          router.replace('/')
        } else {
          Toast.fail(message)
        }
        return Promise.reject(data)
      }

      return data
    }, error => {

      return Promise.reject(error)
    })
  }

  get(url, params) {
    return this.service.get(url, { params }).catch(this.validateStatus)
  }

  post(url, data, config = {}) {
    return this.service.post(url, data, config).catch(this.validateStatus)
  }

  validateStatus(error) {
    return new Promise((resolve, reject) => {
      if (error && error.response) {
        const { errorCode = 500, data = {}, statusText = '服务器错误' } = error.response
        let errorMessage = ''

        switch (errorCode) {
          case 500:
            errorMessage = data.msg || '服务器错误'
            break
          default:
            errorMessage = statusMessage[errorCode] || statusText
            break
        }

        Toast.fail(errorMessage)
      } else {
        if (error.code === 'ECONNABORTED') {
          Toast.fail('连接超时')
        }
      }

      reject(error)
    })
  }
}

export default new HttpRequest()
